import React from 'react';
import styled from 'styled-components';
import Typography from 'kingpin/atoms/Typography';
import { TOP_BAR_HEIGHT } from '../../../../../constants';

const ModeBarDiv = styled.div`
  height: ${TOP_BAR_HEIGHT}px;
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 0 24px;
  gap: 24px;
  border-bottom: 1px solid var(--color-border-secondary);
`;

const TabDiv = styled.div<{ isSelected: boolean }>`
  height: 100%;
  border-bottom: 1px solid
    ${(props) =>
      props.isSelected ? 'var(--color-text-primary)' : 'transparent'};
  display: flex;
  flex-direction: column;
  justify-content: center;
  cursor: pointer;
  &:hover {
    opacity: 0.7;
  }
`;

const Tab = ({
  label,
  isSelected,
  onClick,
}: {
  label: string;
  isSelected: boolean;
  onClick: () => void;
}) => {
  return (
    <TabDiv isSelected={isSelected} onClick={onClick}>
      {isSelected && (
        <Typography.Body type={'Body 13 Bold'}>{label}</Typography.Body>
      )}
      {!isSelected && (
        <Typography.Body type={'Body 13'}>{label}</Typography.Body>
      )}
    </TabDiv>
  );
};

const ModeBar = ({
  modeOptions,
}: {
  modeOptions: {
    label: string;
    isSelected: boolean;
    onClick: () => void;
    key: string;
  }[];
}) => {
  return (
    <ModeBarDiv>
      {modeOptions.map((o) => (
        <Tab
          key={o.key}
          label={o.label}
          isSelected={o.isSelected}
          onClick={o.onClick}
        />
      ))}
    </ModeBarDiv>
  );
};

export default ModeBar;
